<template>
    <submit-button class="ml-2 text-sm" size="sm" @click.prevent="show = true;">Adicionar</submit-button>
    <modal
        class="min-h-full"
        :open="legalTerm || show"
        @close="show = false"
    >
        <div class="flex flex-col flex-wrap w-full space-y-3 text-white divide-y divide-slate-500 min-h-fit">
        </div>
        <h1 class="flex flex-row flex-wrap items-center content-center pb-1 mb-2 text-sm text-lg font-bold text-white border-b border-slate-500">
            Adicionar termo jurídico
        </h1>

        <legal-term-form @fetch="show= false;$emit('fetch');$emit('resetLegalTerms')" :legalTerm="legalTerm" />
    </modal>
</template>

<script>
    import Modal from "../../layouts/Modal.vue";
    import SubmitButton from "../../forms/SubmitButton.vue";
    import LegalTermForm from "../LegalTermForm.vue";

    export default {
        props: {legalTerm: {type: Object, default: null}},
        components: {LegalTermForm, SubmitButton, Modal},
        emits: ['fetch'],
        data() {
            return {
                show: false,
            }
        },
    }
</script>
